import * as SplashScreen from 'expo-splash-screen';
import React from 'react';

import { useAuthentication } from '@context/AuthContext';
import { AppErrorScreen, AppLoadingScreen } from '@navigation/AppGateScreens';
import AuthStack from '@navigation/AuthStack';
import AuthenticatedStack from '@navigation/AuthenticatedStack';

export default function AppStack() {
  const { loading, loggedIn, error } = useAuthentication();

  React.useEffect(() => {
    if (!loading) {
      SplashScreen.hide();
    }
  }, [loading]);

  if (error) {
    return <AppErrorScreen />;
  }

  if (loading) {
    return <AppLoadingScreen />;
  }

  if (loggedIn) {
    return <AuthenticatedStack />;
  }

  return <AuthStack />;
}
